import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  TextField,
} from "@mui/material";

const TitleInputDialog = ({ open, onClose, onSave, dialogTitle = "Enter Title", label = "Title", description }) => {
  const [value, setValue] = useState("");

  const handleSave = () => {
    if (value.trim()) {
      onSave(value);
      onClose();
      setValue("");
    }
  };

  const handleClose = () => {
    onClose();
    setValue("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "14px",
          background: "#fff",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: { xs: "16px", lg: "18px" },
          color: "#303f9f",
          fontWeight: "bold",
          textAlign: "center",
          paddingBottom: "12px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        {dialogTitle}
      </DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", marginTop: "20px" }}>
        <Typography textAlign="left" sx={{ marginBottom: 2, fontSize: { xs: "13px", lg: "14px" } }}>
          {description || "Please provide a title for your document"}
        </Typography>
        <TextField
          size="small"
          required
          fullWidth
          label={label}
          variant="outlined"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          InputProps={{ sx: { fontSize: "13px" } }}
          InputLabelProps={{ sx: { fontSize: "13px" } }}
          sx={{ marginBottom: 2 }}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", marginTop: 2 }}>
        <Button
          onClick={handleClose}
          color="error"
          variant="outlined"
          sx={{ borderRadius: "24px", padding: "8px 24px", textTransform: "none", fontWeight: "bold" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={!value.trim()}
          sx={{ borderRadius: "24px", padding: "8px 24px", textTransform: "none", fontWeight: "bold" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TitleInputDialog;